import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from './Texte';
import { CalendarClock } from './icons';
import type { SubscriptionSource } from '../utils/subscriptionExpiry';
import { colors, radius, spacing, typography } from '../theme/tokens';

// Rappel d'échéance. Rendu uniquement quand `days` est fourni (cf. expiryReminderDays).
// `source` distingue une vraie souscription d'un accès accordé en base (bêta) : parler
// d'« abonnement » à un testeur qui n'a jamais payé serait faux, et le mot compte ici.
export function SubscriptionExpiryNotice({
  days,
  source,
  testID,
}: {
  days: number;
  source: SubscriptionSource;
  testID?: string;
}) {
  const message =
    source === 'granted'
      ? days <= 0
        ? 'Ton accès bêta se termine aujourd’hui.'
        : days === 1
          ? 'Dans 1 jour, ton accès bêta se termine.'
          : `Dans ${days} jours, ton accès bêta se termine.`
      : days <= 0
        ? 'Ton abonnement arrive à échéance aujourd’hui.'
        : days === 1
          ? 'Dans 1 jour, ton abonnement touchera à sa fin.'
          : `Dans ${days} jours, ton abonnement touchera à sa fin.`;

  return (
    <View testID={testID} style={styles.card}>
      <View style={styles.iconWrap}>
        <CalendarClock size={20} color={colors.corail} strokeWidth={2} />
      </View>
      <Text style={styles.text}>{message}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.md,
    padding: spacing.lg,
    borderRadius: radius.lg,
    backgroundColor: colors.corailSoft,
    borderWidth: 1,
    borderColor: colors.corail,
  },
  iconWrap: {
    width: 40,
    height: 40,
    borderRadius: radius.md,
    backgroundColor: colors.white,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: { flex: 1, fontSize: typography.bodyMd.size, fontWeight: typography.bodyMd.weight, color: colors.grey900 },
});
